const ro = {
  sinObra: "Fără șantier",
  cat: { materiales: "Materiale", mano_obra: "Manoperă", subcontratas: "Subcontractori", suministros: "Utilități", fiscal: "Fiscal / Impozite" },
  rama: {
    albanil_oficial: "Zidar calificat", fontanero: "Instalator", electricista: "Electrician", carpinteria_madera: "Tâmplărie lemn",
    carpintero_aluminio: "Tâmplar aluminiu", gestion_residuos: "Gestionarea deșeurilor", transportes: "Transporturi",
    peones: "Muncitori necalificați / Ajutoare", gestiones_comerciales: "Activități comerciale",
  },
  exento: { si: "Scutit", marcar: "Marchează scutit", marcado: "Cheltuială marcată ca scutită", quitado: "Cheltuiala nu mai este marcată ca scutită", error: "Cheltuiala nu a putut fi actualizată" },
  toast: {
    subida: "Imagine încărcată", leyendo: "Imagine încărcată · se citesc datele facturii…", leidos: "Datele facturii au fost citite automat ✨",
    noLeidos: "Datele nu au putut fi citite automat. Completează-le manual.", errorSubir: "Imaginea nu a putut fi încărcată",
    registrado: "Cheltuială înregistrată", eliminado: "Cheltuială ștearsă",
  },
  jornada: {
    titulo: "Program de lucru pe șantier (limită {{n}}h/săptămână)", totales: "{{n}}h în total",
    excesoObras: "{{n}} șantier(e)", excesoTexto: "depășesc {{n}}h de manoperă pe săptămână. Verifică volumul de muncă.",
    vacio: "Încă nu există ore de manoperă înregistrate. Adaugă o cheltuială din categoria «Manoperă» cu șantierul și orele.",
    semExcedidas: "{{n}} săpt. depășită(e)", resumen: "{{h}}h · {{n}} săptămână(i)", excesoSemana: "{{h}}h peste limita legală de {{n}}h.",
  },
  coste: { titulo: "Cost pe șantier", ver: "Vezi Șantiere / Proiecte →", obra: "Șantier", materiales: "Materiale", manoObra: "Manoperă", total: "Cost total" },
  vacio: { titulo: "Nicio cheltuială", hint: "Înregistrează facturi de materiale, manoperă și subcontractori" },
  tabla: { concepto: "Descriere", categoria: "Categorie", fecha: "Data", horas: "Ore", total: "Total", justificante: "justificativ", justificanteM: "Justificativ" },
  form: {
    escanea: "Scanează factura și completăm noi datele", quitar: "Elimină imaginea", leyendo: "Se citește…", camara: "Scanează cu camera",
    subir: "Încarcă fișier", analizando: "Se analizează imaginea…",
    ocrBloqueado: "Poți atașa imaginea; citirea automată cu IA este disponibilă începând cu Planul Trimestrial.",
    concepto: "Descriere", categoria: "Categorie", proveedor: "Furnizor / Firmă", base: "Bază (€)", impuesto: "Taxă",
    obra: "Șantier / Proiect", irpf: "Reținere IRPF (profesioniști)", sinRetencion: "Fără reținere",
    isp: "Taxare inversă", ispNota: "(subcontractor de construcții care te facturează fără TVA sau IGIC)",
    exento: "Scutit de taxă", exentoNota: "(asigurări, taxe, chirie de locuință…)",
    horas: "Ore", rama: "Domeniu de activitate", datosFactura: "Datele facturii", numero: "Nr. factură", hora: "Ora achiziției",
    nif: "NIF / CIF firmă", registro: "Nr. registrul comerțului", opcional: "Opțional", fecha: "Data",
  },
};

export default ro;
